import { render, staticRenderFns } from "./SliderImages.vue?vue&type=template&id=5cffab9c&scoped=true&"
import script from "./SliderImages.vue?vue&type=script&lang=js&"
export * from "./SliderImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cffab9c",
  null
  
)

export default component.exports